import api from "../../../api";

export function rewardsApi(caseId, year, month) {
  return api.get(
    `bahHistory/${caseId}?year=${year}&month=${month}&isCreditTxn=${true}&isDebitTxn=${true}`
  );
}

export const addRewardsApi =()=>{
  return api.get(`streakMaster`)
}

export const afterAddRewardsApi =(id ,data)=>{
  return api.post(`extraRewardsToUser/${id}`, {
    ...data,
  })
}
export const syncBalanceApi =(id)=>{
  return api.put(`syncRewardBalanceWithShopFlo/${id}`)
}
